import gql from 'graphql-tag';

export const INSERT_POST_ONE = gql`mutation insert_post_one ($object: post_insert_input!) {
    insert_post_one(object: $object) {
        id
    }
}`

// _or: [
//     {cognito_user: {disabled: {_eq: false}}},
//     {list_user: {disabled: {_eq: false}}}
// ]

// e9b50009-5c68-467b-93f8-e9a036e2abd1

export const SUBSCRIBE_POSTS = gql`
subscription presentation_by_pk ($id: String!) {
    presentation_by_pk(id: $id) {
        id
        speaker_id
        association_id
        posts {
            id
            post
            created_at
            user {
                id
                name
                photo
                is_moderator
            }
            liked_by_user
            likes
            debug

            replies {
                id
                reply
                created_at
                user {
                    id
                    name
                    photo
                    is_moderator
                }
                liked_by_user
                likes
            }
        }
    }
}
`

export const DELETE_POST = gql`
    mutation ($id: uuid!) {
        delete_post_by_pk(id: $id) {
            id
        }
    }
`

export const INSERT_POST_LIKE_ONE = gql`
    mutation ($post_id: uuid!) {
        insert_post_like_one (object: {
            post_id: $post_id
        }) {
            post_id
        }
    }
`

export const DELETE_POST_LIKE_BY_PK = gql`
    mutation ($post_id: uuid!) {
        delete_post_like (where: {
            post_id: {
                _eq: $post_id
            }
        }) {
            affected_rows
        }
    }
`

export const INSERT_POST_REPLY_ONE = gql`mutation insert_post_reply_one ($object: post_reply_insert_input!) {
    insert_post_reply_one(object: $object) {
        id
    }
}`

export const DELETE_POST_REPLY = gql`
    mutation ($id: uuid!) {
        delete_post_reply_by_pk(id: $id) {
            id
        }
    }
`

export const INSERT_POST_REPLY_LIKE_ONE = gql`
    mutation ($post_reply_id: uuid!) {
        insert_post_reply_like_one(object: {
            post_reply_id: $post_reply_id
        }) {
            post_reply_id
        }
    }
`

export const DELETE_POST_REPLY_LIKE_BY_PK = gql`
    mutation (
        $id: uuid!
    ) {
        delete_post_reply_like_by_pk (
            id: $id
        ) {
            post_reply_id
        }
    }
`
